// extracted by mini-css-extract-plugin
module.exports = {"container":"SellTradeHero-module__container","flex":"SellTradeHero-module__flex","infoArea":"SellTradeHero-module__infoArea","imageHolder":"SellTradeHero-module__imageHolder"};